import partnerClient from "../partnerClient";

export const fetchPartnerDashboard = async () => {
  const { data } = await partnerClient.get("/dashboard");
  return data?.data ?? data;
};

export const fetchPartnerClients = async (params) => {
  const { data } = await partnerClient.get("/clients", { params });
  return data?.data ?? data;
};

export const fetchPartnerClient = async (clientId) => {
  const { data } = await partnerClient.get(`/clients/${clientId}`);
  return data?.data ?? data;
};

export const fetchPartnerAppointments = async (params) => {
  const { data } = await partnerClient.get("/appointments", { params });
  return data?.data ?? data;
};

export const fetchPartnerPriceList = async (params) => {
  const { data } = await partnerClient.get("/price-list", { params });
  return data?.data ?? data;
};

export const fetchPartnerChecklists = async (params) => {
  const { data } = await partnerClient.get("/checklists", { params });
  return data?.data ?? data;
};

export const fetchPartnerCourse = async (courseId) => {
  const { data } = await partnerClient.get(`/courses/${courseId}`);
  return data?.data ?? data;
};

export const fetchPartnerCourses = async (params) => {
  const { data } = await partnerClient.get("/courses", { params });
  return data?.data ?? data;
};

/** Office members (admin, account, super admin) a partner can book a meeting with. */
export const fetchPartnerAppointmentStaff = async () => {
  const { data } = await partnerClient.get("/appointments/staff", {
    params: { page: 0, size: 100 },
  });
  return (data?.data ?? data)?.content ?? [];
};

export const bookPartnerAppointment = async (body) => {
  const { data } = await partnerClient.post("/appointments", body);
  return data?.data ?? data;
};

export const cancelPartnerAppointment = async (appointmentId) => {
  const { data } = await partnerClient.post(`/appointments/${appointmentId}/cancel`);
  return data?.data ?? data;
};
